export default class GetAllPersonalByConvocatoria {
  #repository
  constructor(repository) {
    this.#repository = repository
  }
  async execute(idConvocatoria) {
    try {
      const result = await this.#repository.getAllPersonalByConvocatoria(idConvocatoria)
      return result
    } catch (error) {
      console.error('Error al obtener el personal por convocatoria:', error)
      throw error
    }
  }
}
